import {datadogLogs} from '@datadog/browser-logs';
import {datadogRum} from '@datadog/browser-rum';

import {envIsServerDeployment} from '../../config';
import {initDatadogLogs} from './datadogLogs';
import {disableSaasDatadogAtRuntime, getDatadogMode} from './datadogMode';
import {initDatadogRum} from './datadogRum';

/**
 * Initializes eligible telemetry, respecting mode policy and SaaS-only shutdown.
 * Use from the consent-aware startup flow; callers need not duplicate the gates.
 * Server mode initializes RUM only; SaaS mode also initializes browser logs.
 */
export function initDatadog() {
  const mode = getDatadogMode();
  if (mode == null) {
    return;
  }
  if (mode === 'saas') {
    initDatadogLogs();
  }
  initDatadogRum(mode);
}

/**
 * Revokes SaaS logs/RUM consent and sets the runtime shutdown flag.
 * Development debug can bypass that flag, but does not restore SDK consent.
 * Use for SaaS admin-mode shutdown. This is a no-op on server deployments.
 */
export function disableDatadog() {
  if (envIsServerDeployment) {
    return;
  }
  disableSaasDatadogAtRuntime();
  datadogLogs.setTrackingConsent('not-granted');
  datadogRum.setTrackingConsent('not-granted');
}

/**
 * Checks mode eligibility and, for SaaS only, runtime shutdown.
 * Use for runtime guards; use getDatadogMode() for mode-specific configuration.
 * This does not indicate whether the SDK has already initialized.
 */
export function datadogEnabled() {
  return getDatadogMode() != null;
}
